import { styles } from 'src/variables';
import styled from 'styled-components';

export const HomeContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${styles.gap.medium};
`;

export const WifiContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 350px;
`;

export const WifiTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    background: #E4E4E7;
    padding: 12px;
    border-radius: 15px;
    gap: 12px;
`;

export const WifiTextTitle = styled.p`
    font-size: 16px;
    line-height: 1.7; 
    font-weight: 500;
    color: #1C1C1C;
    flex: 1
`;

export const WifiText = styled.p`
    font-size: 16px;
    line-height: 1.7; 
    font-weight: 400;
    color: #3F3F46;
`;

export const SocialMediaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 350px;
`;

export const SocialMediaButton = styled.a`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    border: 1px solid  #E4E4E7;
    padding: 12px;
    border-radius: 15px;
    align-items: center;
    gap: ${styles.gap.small};
    cursor: pointer;
`;

export const ButtonContainer = styled.a`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background: #FFF;
    border: 1px solid #E4E4E7;
    padding: 12px;
    border-radius: 15px;
    align-items: center;
    gap: ${styles.gap.small};
    cursor: pointer;
`;

export const SocialMediaText = styled.p`
    font-size: 16px;
    line-height: 1.7; 
    font-weight: 400;
    color: #1C1C1C;
    flex: 1
`;

export const OpinionIcon = styled.img`
    width: 28px;
    height: 28px;
`;

export const MenuGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    @media (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }
`;
